import { useEffect, useState } from 'react';

const useDeferredLoading = (isLoading: boolean, timeout: number) => {
    const [isDeferredLoading, setIsDeferredLoading] = useState<boolean>(false);

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (isLoading) {
            // Start the timer when loading begins
            timer = setTimeout(() => {
                setIsDeferredLoading(true);
            }, timeout);
        } else {
            // Reset state if loading ends early
            setIsDeferredLoading(false);
            clearTimeout(timer);
        }

        return () => clearTimeout(timer);
    }, [isLoading, timeout]);

    return [isDeferredLoading, setIsDeferredLoading] as const;
};

export default useDeferredLoading;
